import { render } from "./VendorList.vue?vue&type=template&id=8cc37d8c&scoped=true"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"

import "./VendorList.vue?vue&type=style&index=0&id=8cc37d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc37d8c"]])

export default __exports__